import type {State} from 'src/reducers';


export const selectReleaseFlags = (
  state: State,
): {
  [key: string]: boolean;
} => state.productFlags.releaseFlags;
